<template>
<div class="card-item"
  :id="item.itemId">
  <div class="card-item-heading">経営者略歴</div>
  <div class="card-item-content">
    <div class="carrer">
      <div class="carrer-item"
        v-for="(history, index) in item.data.histories"
        :index="index">
        <div class="carrer-item-input">
          <my-date v-bind:date="history.date"
            v-bind:termDate="history.termDate" />
          <div class="comment">
            <Input type="textarea"
              :autosize="{minRows: 1,maxRows: 10}"
              placeholder="業務内容や役職、会社に貢献した内容など"
              v-model="history.desc" />
          </div>
        </div>
        <div class="delete-item">
          <Button @click="destroyHistory(index)" shape="circle" icon="ios-trash-outline"></Button>
        </div>
      </div>
    </div>
    <div class="add-item">
      <Button shape="circle"
        icon="md-add"
        @click="addHistory()"></Button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: ['item', 'groupIndex', 'itemIndex'],
  computed: {},
  mounted: function () {},
  methods: {
    addHistory: function () {
      this.$eventHub.$emit(
        'addItem',
        this.groupIndex,
        this.itemIndex,
        'histories'
      )
    },
    destroyHistory: function (index) {
      this.$eventHub.$emit(
        'destroyItem',
        this.groupIndex,
        this.itemIndex,
        'histories',
        index
      )
    }
  }
}
</script>
